<template>
  <div>
    <v-dialog :value="visible" width="500" persistent>
      <v-card>
        <v-card-title class="text-h6">Sätt nytt lösenord</v-card-title>
        <v-card-text>
          <v-alert dense type="info">
            Endast administratörer och utvecklare kan sätta nya lösen utan att ange nuvarande.
          </v-alert>
          <v-form ref="form">
            <v-text-field
              label="Nytt lösenord"
              outlined
              :rules="[rules.required]"
              v-model="newPassword"
              :type="showNewPassword ? 'text' : 'password'"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showNewPassword = !showNewPassword"
            ></v-text-field>
            <v-text-field
              label="Upprepa nytt lösenord"
              :rules="[rules.required, matchingPasswords]"
              outlined
              v-model="newPasswordRepeat"
              :type="showNewPasswordRepeat ? 'text' : 'password'"
              :append-icon="showNewPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showNewPasswordRepeat = !showNewPasswordRepeat"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="onClose"> Avbryt </v-btn>
          <v-btn color="primary" :loading="loading" :disabled="!canSubmit" @click="onSave">
            Spara
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Message ref="message" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Message from '@/components/shared/Message'

export default {
  name: 'UserSetPassword',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Message,
  },

  data: () => ({
    loading: false,
    showNewPassword: false,
    showNewPasswordRepeat: false,
    newPassword: '',
    newPasswordRepeat: '',
    rules: {
      required: (value) => !!value || 'Obligatoriskt',
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Ogiltig e-mail.'
      },
    },
  }),
  computed: {
    ...mapGetters('auth', { getCurrentUserId: 'currentUserId' }),
    canSubmit() {
      return (
        this.newPassword && this.newPasswordRepeat && this.newPassword === this.newPasswordRepeat
      )
    },
    userId() {
      const id = this.$route.params.id ? this.$route.params.id : null
      if(!id) throw new Error('User id is missing')
      return id
    },
  },
  methods: {
    ...mapActions('auth', { updatePassword: 'updatePassword' }),
    matchingPasswords() {
      if (this.newPassword === this.newPasswordRepeat) {
        return true
      } else {
        return 'Lösenorden är inte lika.'
      }
    },
    onClear() {
      this.$refs.form.reset()
      this.showNewPassword = false
      this.showNewPasswordRepeat = false
      this.newPassword = ''
      this.newPasswordRepeat = ''
    },
    onClose() {
      this.$emit('close')
      this.onClear()
    },
    async onSave() {
      this.loading = true
      const requestPasswordChange = {
        id: this.userId,
        newPassword: this.newPassword,
        newPasswordRepeat: this.newPasswordRepeat,
      }
      await this.updatePassword(requestPasswordChange)
      this.loading = false
      this.$refs.message.open('Lösenord bytt')
      this.onClose()
    },
  },
}
</script>

<style lang="less" scoped></style>
